/* SSS PDP gallery: isolate all product views by current color, every PDP layout. */
(function(){
  if(window.__sssPdpGalleryLoaded)return;window.__sssPdpGalleryLoaded=true;
  const normalize=s=>String(s||'').trim().toLowerCase();
  const stem=s=>{
    if(!s)return'';
    let path;try{path=new URL(s,location.origin).pathname;}catch(e){path=String(s).split('?')[0];}
    let name=decodeURIComponent(path.split('/').pop()||'').replace(/\.[^.]+$/,'');
    return name.replace(/[-_]0[1-9](?:[-_].*)?$/i,'').toLowerCase();
  };
  const products=new Map();
  function metadata(){
    document.querySelectorAll('script[data-sss-gallery-product]').forEach(n=>{
      if(products.has(n.dataset.sssGalleryProduct))return;
      try{const product=JSON.parse(n.textContent);const mediaNode=document.querySelector('script[data-sss-gallery-media="'+n.dataset.sssGalleryProduct+'"]');if(mediaNode)product.media=JSON.parse(mediaNode.textContent);products.set(n.dataset.sssGalleryProduct,product);}catch(e){}
    });
  }
  function imagesFor(product,color){
    const variants=product.variants||[];
    const colorPosition=(product.options||[]).findIndex(o=>normalize(typeof o==='string'?o:o.name).includes('color')||normalize(typeof o==='string'?o:o.name).includes('colour'));
    if(colorPosition<0)return null;
    const matches=variants.filter(v=>normalize(v.options?.[colorPosition])===normalize(color));
    const media=(product.media||[]).filter(m=>m.media_type==='image');
    const src=m=>m?.preview_image?.src||m?.src||m?.image?.src||'';
    const file=m=>{try{return decodeURIComponent(new URL(src(m),location.origin).pathname.split('/').pop()||'');}catch(e){return String(src(m)).split('?')[0].split('/').pop()||'';}};
    const is05=m=>/-(05)(?:_|[.])/i.test(file(m));
    const assigned=new Set(matches.map(v=>stem(v.featured_image?.src||v.featured_media?.preview_image?.src)).filter(Boolean));
    if(assigned.size){
      const valid=[...assigned].filter(prefix=>media.some(m=>stem(src(m))===prefix&&is05(m)));
      return new Set(valid.length?valid:[...assigned]);
    }
    const wanted=' in '+normalize(color);
    const byAlt=media.find(m=>is05(m)&&(()=>{
      const alt=normalize(m.alt);
      const pos=alt.indexOf(wanted);
      return pos>=0 && (!alt[pos+wanted.length]||/[^a-z]/.test(alt[pos+wanted.length]));
    })());
    if(byAlt)return new Set([stem(src(byAlt))]);
    const anyAttached=variants.some(v=>v.featured_image?.src||v.featured_media?.preview_image?.src);
    if(!anyAttached){
      const colors=[...new Set(variants.map(v=>v.options?.[colorPosition]).filter(Boolean).map(normalize))];
      const heroes=media.filter(is05);
      const families=[...new Map(heroes.map(m=>[stem(src(m)),m])).values()];
      const index=colors.indexOf(normalize(color));
      if(index>=0&&families.length===colors.length)return new Set([stem(src(families[index]))]);
    }
    return null;
  }

  // Load the selected color's visible assets immediately, not every product color.
  function primeColorViews(root,product,color,allowed,hover){
    if(!root||!allowed?.size)return;
    const colorOption=(product.options||[]).findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name||''));
    const candidates=(product.variants||[]).filter(v=>colorOption>=0&&normalize(v.options?.[colorOption])===normalize(color));
    const ordering=orderedColorMedia(product,allowed);
    const slides=Array.from(root.querySelectorAll('.product__media-list .product__media-item[data-media-id]'))
      .filter(el=>!el.closest('.product__media-grid-noscript')&&allowed.has((el.dataset.mediaId||'').split('-').pop()));
    const order=(el)=>{
      const id=(el.dataset.mediaId||'').split('-').pop();
      return ordering.rank.get(id)??999999;
    };
    slides.sort((a,b)=>order(a)-order(b));
    slides.slice(0,hover?1:window.innerWidth>=990?3:2).forEach((slide,index)=>{
      slide.querySelectorAll('img').forEach(img=>{
        img.loading='eager';
        img.decoding='async';
        if(index===0)img.fetchPriority='high';
      });
    });
    if(hover)return;
    // Eager loading of small thumbnails is considerably cheaper than full-size views.
    root.querySelectorAll('.product__media-subitem[data-media-sub-id]').forEach(slide=>{
      if(!allowed.has((slide.dataset.mediaSubId||'').split('-').pop()))return;
      slide.querySelectorAll('img').forEach(img=>{
        img.loading='eager';
        img.decoding='async';
        img.fetchPriority='low';
      });
    });
  }

  // New approved 01 photography is different from legacy 01 imagery.
  // New 01 leads, Azura OF-FALL-01 follows, then 05 / 02 / 03 / 06 / 07.
  // For older styles, 05 remains the hero and obsolete 01 is suppressed.
  const VIEW_SEQUENCE=['05','02','03','06','07'];
  function orderedColorMedia(product,allowed){
    const entries=(product.media||[]).filter(m=>allowed.has(String(m.id)));
    const filename=(media)=>{
      const src=media?.preview_image?.src||media?.src||media?.image?.src||'';
      let pathname;
      try{pathname=new URL(src,location.origin).pathname;}
      catch(e){pathname=String(src).split('?')[0];}
      return decodeURIComponent(pathname.split('/').pop()||'');
    };
    const view=(m)=>filename(m).match(/-(0[1-9])(?:_|[.])/i)?.[1]||'';
    const isAzura=normalize(product.vendor)==='azura';
    const onFootView=m=>isAzura && /-OF-FALL-01(?:_|[.])/i.test(filename(m));
    const isUpdated01=m=>{
      if(m.media_type!=='image'||view(m)!=='01'||onFootView(m))return false;
      const alt=String(m.alt||m.preview_image?.alt||'');
      const file=filename(m);
      const mediaFamily=file.replace(/-01(?:_|[.]).*$/i,'').toUpperCase();
      const specialShot=entries.some(onFootView);
      const approvedAzura=Boolean(isAzura && window.__sssAzuraUpdatedFamilies?.has(mediaFamily));
      // Explicit asset labels and the previously approved Azura media list
      // distinguish genuinely refreshed front images from legacy 01 files.
      return specialShot||approvedAzura||
        /\bfront view\b|\bupdated 01\b|\bnew hero\b/i.test(alt)||
        /-01[-_](?:NEW|UPDATED|FW26|FALL26)(?:[-_.]|$)/i.test(file);
    };
    const all01=entries.filter(m=>m.media_type==='image'&&view(m)==='01'&&!onFootView(m));
    const updated01=all01.find(isUpdated01);
    const hasOnFoot=entries.some(onFootView);
    const present=new Set(entries.filter(m=>m.media_type==='image'&&!onFootView(m)).map(view));
    const completeRefreshedSet=VIEW_SEQUENCE.every(v=>present.has(v));
    const selected=new Set(allowed);
    if(completeRefreshedSet){
      all01.forEach(m=>{if(!updated01||m!==updated01)selected.delete(String(m.id));});
    }
    const rank=new Map();
    entries.forEach((m,index)=>{
      const v=view(m);
      const onFoot=onFootView(m);
      const new01=updated01===m;
      // 01 hero and lifestyle shot remain first for updated styles.
      const position=new01?0:onFoot?(updated01?1:2):
        v==='05'?(updated01?2:0):
        v==='02'?3:v==='03'?4:v==='06'?5:v==='07'?6:v==='01'?8:10;
      rank.set(String(m.id),position*10000+index);
    });
    return {selected,rank,completeRefreshedSet,hasUpdated01:Boolean(updated01),hasOnFoot};
  }
  function orderVisibleGallery(root,modal,selected,rank){
    let changed=false;
    [root,modal].filter(Boolean).forEach(scope=>{
      scope.querySelectorAll('.product__media-list,.product__media-sublist,.js-popup-slider,.js-popup-sublist')
        .forEach(list=>{
          if(list.closest('.product__media-grid-noscript'))return;
          const track=list.querySelector(':scope > .swiper-wrapper')||list;
          const slides=Array.from(track.children).filter(el=>el.matches?.(
            '.product__media-item[data-media-id],.product__media-subitem[data-media-sub-id],.product-media-modal__item[data-media-modal-id]'
          ));
          const idOf=el=>(el.dataset.mediaId||el.dataset.mediaSubId||el.dataset.mediaModalId||'').split('-').pop();
          const front=slides.filter(el=>selected.has(idOf(el)));
          if(front.length<1)return;
          front.sort((a,b)=>(rank.get(idOf(a))??999999)-(rank.get(idOf(b))??999999));
          front.forEach((slide,index)=>{
            if(track.children[index]!==slide){
              track.insertBefore(slide,track.children[index]||null);
              changed=true;
            }
          });
        });
    });
    return changed;
  }
  function ensureLandingColor(product,sectionId){
    const options=product.options||[];
    const opt=options.findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name||''));
    if(opt<0)return;
    const picker=document.querySelector('variant-radios[data-section="'+sectionId+'"],variant-selects[data-section="'+sectionId+'"]');
    if(!picker)return;
    const id=new URLSearchParams(location.search).get('variant');
    const variants=product.variants||[];
    const fromUrl=variants.find(v=>String(v.id)===id);
    const chosen=fromUrl||variants.find(v=>v.available)||variants[0];
    const color=chosen?.options?.[opt];
    if(!color)return;
    const controls=[...picker.querySelectorAll('input[type="radio"]')].filter(el=>/colou?r/i.test(el.name||''));
    const target=controls.find(el=>normalize(el.value)===normalize(color));
    if(target){
      if(!picker.dataset.sssLandingColorApplied){
        controls.forEach(el=>{el.checked=(el===target);});
        picker.dataset.sssLandingColorApplied='1';
      }else if(!controls.some(el=>el.checked)){
        target.checked=true;
      }
    }
    const selected=controls.find(el=>el.checked);
    const label=document.getElementById('ColorName-'+sectionId);
    if(selected&&label)label.textContent=selected.value;
  }
  function currentColor(product,sectionId){
    const opt=(product.options||[]).findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name));
    if(opt<0)return null;
    const picker=document.querySelector('variant-radios[data-section="'+sectionId+'"],variant-selects[data-section="'+sectionId+'"]');
    if(picker){
      const controls=picker.querySelectorAll('.product-form__controls');
      for(const group of controls){
        const title=normalize(group.querySelector('legend,.product-form__group-name,.product-form__label,.form__label')?.textContent);
        if(!title.includes('color')&&!title.includes('colour'))continue;
        const selected=group.querySelector('input:checked,select');
        if(selected)return selected.value;
      }
      const selected=picker.querySelectorAll('input:checked,select');
      if(selected[opt])return selected[opt].value;
    }
    const id=new URLSearchParams(location.search).get('variant');
    const variant=(product.variants||[]).find(v=>String(v.id)===id)||(product.variants||[]).find(v=>v.available)||(product.variants||[])[0];
    return variant?.options?.[opt]||null;
  }
  const shownColors=new Map();
  function apply(){
    metadata();
    products.forEach((product,sectionId)=>{
      const root=document.getElementById('MainProduct-'+sectionId);
      if(!root)return;
      ensureLandingColor(product,sectionId);
      const color=currentColor(product,sectionId);
      const prefixes=imagesFor(product,color);
      if(!prefixes){root.classList.add('sss-gallery-ready');return;}
      const media=product.media||[];
      const allowed=new Set();
      for(const m of media){
        if(m.media_type!=='image'){allowed.add(String(m.id));continue;}
        const src=m.preview_image?.src||m.src||m.image?.src||'';
        const s=stem(src);
        // Azura's OF-FALL-01 on-foot shot is style-level media (no color code).
        // Keep it in the selected-color gallery without exposing other colorways.
        const azuraOnFoot=normalize(product.vendor)==='azura' &&
          /-OF-FALL-01(?:_[^/.?]+)?\.(?:png|jpe?g|webp|avif)(?:[?#]|$)/i.test(src);
        if(prefixes.has(s)||azuraOnFoot)allowed.add(String(m.id));
      }
      if(!allowed.size){root.classList.add('sss-gallery-ready');return;}
      const modal=document.getElementById('ProductModal-'+sectionId);
      // Never hide a complete media set until the selected color's images are
      // present in the actual gallery DOM. This protects against delayed theme
      // section renders, app updates, and mismatched legacy media filenames.
      const gallerySlides=[...root.querySelectorAll('.product__media-list .product__media-item[data-media-id]')];
      const galleryIds=new Set(gallerySlides.map(el=>(el.dataset.mediaId||'').split('-').pop()));
      const matchingSlides=[...allowed].filter(id=>galleryIds.has(String(id)));
      if(gallerySlides.length>1 && matchingSlides.length<2 && allowed.size>1){
        [root,modal].filter(Boolean).forEach(container=>{
          container.querySelectorAll('.sss-other-color-media').forEach(el=>{
            el.classList.remove('sss-other-color-media');
            el.setAttribute('aria-hidden','false');
          });
          container.querySelectorAll('.swiper').forEach(el=>{try{el.swiper?.update();}catch(e){}});
        });
        root.classList.add('sss-gallery-ready');
        return;
      }
      // Keep initial page load light; eagerly request additional images only
      // when the customer switches to a different color.
      const previousColor=shownColors.get(sectionId);
      shownColors.set(sectionId,normalize(color));
      const colorChanged=previousColor!==undefined&&previousColor!==normalize(color);
      const ordering=orderedColorMedia(product,allowed);
      if(colorChanged)primeColorViews(root,product,color,ordering.selected,false);
      let changed=orderVisibleGallery(root,modal,ordering.selected,ordering.rank);
      [root,modal].filter(Boolean).forEach(container=>{
        container.querySelectorAll('.product__media-item[data-media-id],.product__media-subitem[data-media-sub-id],.product-media-modal__item[data-media-modal-id]').forEach(el=>{
          const key=el.dataset.mediaId||el.dataset.mediaSubId||el.dataset.mediaModalId||'';
          const id=key.split('-').pop();
          if(!/^\d+$/.test(id))return;
          const show=ordering.selected.has(id);
          if(el.classList.contains('sss-other-color-media')===show){
            el.classList.toggle('sss-other-color-media',!show);
            changed=true;
          }
          const aria=show?'false':'true';
          if(el.getAttribute('aria-hidden')!==aria)el.setAttribute('aria-hidden',aria);
        });
      });
      if(changed){
        [root,modal].filter(Boolean).forEach(container=>{
          container.querySelectorAll('.swiper').forEach(el=>{
            const swiper=el.swiper;
            if(!swiper||swiper.destroyed)return;
            try{
              swiper.update();
              // Keep the 05 hero first after a color change or DOM reorder.
              if(colorChanged||changed)swiper.slideTo(0,0,false);
            }catch(e){}
          });
        });
      }
      root.classList.add('sss-gallery-ready');
    });
  }
  let timeout;
  const schedule=()=>{clearTimeout(timeout);timeout=setTimeout(apply,30);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});else apply();
  // Handle the color switch before the Shopify async variant-section fetch.
  document.addEventListener('change',e=>{
    if(e.target.closest('variant-radios,variant-selects'))apply();
  },true);
  // Desktop hover starts the hero request before clicking (max three previews).
  const warmed=new Set();
  let warmTimer;
  document.addEventListener('pointerover',e=>{
    if(e.pointerType!=='mouse')return;
    const label=e.target?.closest?.('label');
    const picker=label?.closest('variant-radios[data-section],variant-selects[data-section]');
    const group=label?.closest('.product-form__controls--colors');
    if(!picker||!group)return;
    const option=Array.from(group.querySelectorAll('input[type="radio"]')).find(el=>el.id===label.htmlFor);
    if(!option)return;
    const key=picker.dataset.section+':'+normalize(option.value);
    if(warmed.has(key)||warmed.size>=3)return;
    clearTimeout(warmTimer);
    warmTimer=setTimeout(()=>{
      metadata();
      const product=products.get(picker.dataset.section);
      const root=document.getElementById('MainProduct-'+picker.dataset.section);
      const prefixes=product&&imagesFor(product,option.value);
      if(!root||!prefixes)return;
      const ids=new Set((product.media||[]).filter(m=>
        m.media_type==='image'&&prefixes.has(stem(m.preview_image?.src||m.src||''))
      ).map(m=>String(m.id)));
      warmed.add(key);
      primeColorViews(root,product,option.value,ids,true);
    },90);
  },true);
  document.addEventListener('sss:variant-picker-updated',schedule);
  document.addEventListener('shopify:section:load',schedule);
  new MutationObserver(m=>{if(m.some(x=>x.addedNodes.length&&Array.from(x.addedNodes).some(n=>n.nodeType===1&&(n.matches?.('[data-section^="product-media-"]')||n.querySelector?.('[data-section^="product-media-"]')))))schedule();}).observe(document.documentElement,{childList:true,subtree:true});
})();